import 'intl';
import 'intl/locale-data/jsonp/en';
import 'intl/locale-data/jsonp/ru';

import {addLocaleData} from 'react-intl';

import enLocaleData from 'react-intl/locale-data/en';
import ruLocaleData from 'react-intl/locale-data/ru';

addLocaleData([...enLocaleData, ...ruLocaleData]);

import enMessages from './en.yml';
import ruMessages from './ru.yml';

import flat from 'flat';

export default {
  en: flat(enMessages),
  ru: flat(ruMessages)
};



// WEBPACK FOOTER //
// ./locales/index.js